var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"order-filters"},[_c('DatePickerField',{attrs:{"range":true},on:{"change":(date) => _vm.$emit('dateChange', date)}}),_c('v-switch',{staticClass:"ml-6",attrs:{"label":"Nur Errors zeigen"},model:{value:(_vm.errorsOnly),callback:function ($$v) {_vm.errorsOnly=$$v},expression:"errorsOnly"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }